(function(){

	if ( window.__pdpColorSwapInit ) return;
	window.__pdpColorSwapInit = true;

	function getVariantGroups(root){
		return [...root.querySelectorAll('[data-js-product-variant]')];
	}

	function getSizeGroupIndex(root){
		return getVariantGroups(root).findIndex(g => g.querySelector('.product-variant__item--size'));
	}

	function getCurrentSize(root){
		const idx = getSizeGroupIndex(root);
		if ( idx === -1 ) return null;
		const checked = getVariantGroups(root)[idx].querySelector('input[type="radio"]:checked');
		return checked ? checked.value : null;
	}

	function getAvailableSizes(root){
		const idx = getSizeGroupIndex(root);
		if ( idx === -1 ) return null;
		const dataScript = root.querySelector('product-variants script[type="application/json"]');
		if ( ! dataScript ) return null;
		let variants;
		try {
			variants = JSON.parse(dataScript.textContent);
		} catch(e) {
			return null;
		}
		const optionKey = 'option' + (idx + 1);
		const available = new Set();
		variants.forEach(variant => {
			if ( variant.available ) available.add(String(variant[optionKey]));
		});
		return available;
	}

	function pickTargetSize(previousSize, availableSizes){
		if ( ! availableSizes || availableSizes.size === 0 ) return null;
		if ( previousSize !== null && availableSizes.has(previousSize) ) return previousSize;

		const previousNum = parseFloat(previousSize);
		if ( isNaN(previousNum) ) return null;

		const numeric = [...availableSizes]
			.map(value => ({ value, num: parseFloat(value) }))
			.filter(entry => ! isNaN(entry.num));

		const above = numeric.filter(entry => entry.num > previousNum).sort((a, b) => a.num - b.num);
		if ( above.length ) return above[0].value;

		// Nothing available above the previous size — fall back to the closest one below.
		const below = numeric.filter(entry => entry.num < previousNum).sort((a, b) => b.num - a.num);
		return below.length ? below[0].value : null;
	}

	function reviveScripts(root){
		// innerHTML never executes <script> tags — this section relies on a
		// couple of inline scripts (the add-to-cart hidden variant-id input is
		// cloned from a <template> this way), so re-create each one to run it.
		// Only inline scripts: re-fetching src="" component files here would
		// re-run their own page-load init a second time (e.g. desc-section.js
		// would double-bind its accordion listeners) — those already loaded
		// once and stay valid, no re-execution needed.
		root.querySelectorAll('script:not([src])').forEach(oldScript => {
			const newScript = document.createElement('script');
			[...oldScript.attributes].forEach(attr => newScript.setAttribute(attr.name, attr.value));
			newScript.textContent = oldScript.textContent;
			oldScript.replaceWith(newScript);
		});
	}

	function applySize(root, size){
		if ( ! size ) return;
		const idx = getSizeGroupIndex(root);
		if ( idx === -1 ) return;
		const group = getVariantGroups(root)[idx];
		const input = group.querySelector(`input[type="radio"][value="${CSS.escape(size)}"]`);
		if ( input && ! input.checked ) {
			input.checked = true;
			input.dispatchEvent(new Event('change', { bubbles: true }));
		}
	}

	function swap(link){

		const handle = link.dataset.handle;
		const productPage = document.querySelector('[data-pdp-section-id]');
		if ( ! handle || ! productPage ) return;

		const sectionId = productPage.dataset.pdpSectionId;
		const sectionWrapper = document.getElementById(`shopify-section-${sectionId}`);
		if ( ! sectionWrapper ) return;

		const previousSize = getCurrentSize(sectionWrapper);

		sectionWrapper.classList.add('pdp-color-swap-loading');

		fetch(link.href)
			.then(response => {
				if ( ! response.ok ) throw new Error('Request failed');
				return response.text();
			})
			.then(html => {

				const parsed = new DOMParser().parseFromString(html, 'text/html');
				const newSection = parsed.getElementById(`shopify-section-${sectionId}`);
				if ( ! newSection ) throw new Error('Section not found in response');

				sectionWrapper.innerHTML = newSection.innerHTML;
				reviveScripts(sectionWrapper);

				document.title = parsed.title;
				window.history.pushState({}, '', link.href);

				const availableSizes = getAvailableSizes(sectionWrapper);
				applySize(sectionWrapper, pickTargetSize(previousSize, availableSizes));

				if ( typeof window.initDescSection === 'function' ) {
					window.initDescSection();
				}

				if ( typeof window.initSwipeHint === 'function' ) {
					window.initSwipeHint();
				}

			})
			.catch(()=>{
				window.location.href = link.href;
			})
			.finally(()=>{
				sectionWrapper.classList.remove('pdp-color-swap-loading');
			});

	}

	document.addEventListener('click', (event)=>{
		const link = event.target.closest('[data-pdp-color-swap]');
		if ( ! link ) return;
		// Let the browser handle middle-click / Ctrl / Cmd / Shift-click as a
		// normal "open in new tab/window" — only a plain left-click ajax-swaps.
		if ( event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ) return;
		event.preventDefault();
		swap(link);
	});

	// A back/forward navigation across a color swap would otherwise leave the
	// URL and rendered DOM out of sync, since pushState doesn't re-render.
	window.addEventListener('popstate', ()=>{
		window.location.reload();
	});

})();
